var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"noData"},[(!_vm.hideImg)?_c('img',{attrs:{"src":require(("@/assets/" + _vm.imgName + ".png")),"alt":""}}):_vm._e(),_c('div',[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }